module.exports = __webpack_public_path__ + "static/media/nothing.108effa8.svg";